import React from 'react';
import { IMAGES } from '../../../config/images';
import '../Footer/Footer.css'

const Footer = () => {
  return (
    <section id="footer" className="flex-column">
      {/* Навигация в футере */}
      <ul className="navigation footernavigation flex-row">
        <li><a href="#welcome">О приложении</a></li>
        <li><a href="#locationsAndRoutes">Локации&Маршруты</a></li>
        <li><a href="#recommendations">Рекомендации</a></li>
        <li><a href="#footer">Контакты</a></li>
        {/* <li><a href="/users/registry">войти</a></li> */}
      </ul>
      
      <div id="socialMediaWrapper">
        <img className="socialMediaIcon icon" src={IMAGES.telegramIcon} alt="Telegram" />
          <a href="https://vk.com/spb4you_52" target="_blank" rel="noopener noreferrer">
    <img className="socialMediaIcon icon" src={IMAGES.VKIcon} alt="VK" />
  </a>
        <img className="socialMediaIcon icon" src={IMAGES.mailIcon} alt="Email" />
      </div>
      
      <a href="/">
        <img className="logoIconF icon" src={IMAGES.logo} alt="Логотип" />
      </a>
    </section>
  );
};

export default Footer;